// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__248c5","productName":"Table_productName__DNtWK"};